import React from 'react';
import { getBaseUrl } from "../Utils";

interface LoaderBoxProps {
    style?: React.CSSProperties;
    className?: string;
    loadingBoxRef?: React.RefObject<HTMLSpanElement>;
}

const LoaderBox: React.FC<LoaderBoxProps> = ({ 
    style = {}, 
    className = "", 
    loadingBoxRef = null 
}) => {
    const defaultStyle: React.CSSProperties = {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        width: '100%',
       
    };

    return (
        <span 
            ref={loadingBoxRef}
            style={style?style:defaultStyle}
            className={`ajax-loading-box-small-plain ${className}`.trim()}
        >
            <img
                src={`${getBaseUrl()}/images/ajax-loader.gif`}
                alt="Loading..."
                className="image-loading"
            />
        </span>
    );
};

export default LoaderBox;